import { required, TextInput, SimpleForm } from "react-admin";

const validateRequired = [required()];

export const JobApplicationSourceForm = (props: any) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <TextInput source="name" validate={validateRequired} fullWidth />    
  </SimpleForm>
);

export { JobApplicationSourceList } from './List';
export { JobApplicationSourceCreate } from './Create';
export { JobApplicationSourceEdit } from './Edit';
export { JobApplicationSourceIcon } from './Icon';
